// extracted by mini-css-extract-plugin
module.exports = {"title":"title___3CyDj","fa-info-circle":"fa-info-circle___28kpz","dropdown-info-item":"dropdown-info-item___3lxW4"};